import { useResolvedAuth } from "../hooks/useResolvedAuth";
import { PageLoader } from "../components/PageLoader/PageLoader";
import { EventDetail as VolunteerEventDetail } from "./EventDetail";
import { OrganisationEventDetail } from "./OrganisationEventDetail";
import { PublicEventDetail } from "./PublicEventDetail";

export const UniversalEventDetail = () => {
  const { isAuthenticated, currentUser, isAuthResolving } = useResolvedAuth();

  if (isAuthResolving) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <PublicEventDetail />;
  }

  const userType = currentUser?.userType;

  if (userType === "organisation") {
    return <OrganisationEventDetail />;
  }

  return <VolunteerEventDetail />;
};
